import { render, staticRenderFns } from "./appDown.vue?vue&type=template&id=85944b76"
import script from "./appDown.vue?vue&type=script&lang=js"
export * from "./appDown.vue?vue&type=script&lang=js"
import style0 from "./appDown.vue?vue&type=style&index=0&id=85944b76&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports